import React from 'react';
import {FormGroup as BSFormGroup} from 'react-bootstrap';

export interface FormGroupProps extends BSFormGroup.FormGroupProps {   
    
}

export const FormGroup: React.FC<FormGroupProps> = (props) => {   
    return (        
        <BSFormGroup {...props}>{props.children}</BSFormGroup>            
    );
}

(FormGroup as any).displayName = 'FormGroup';